@use '../../styles/variables.scss';
@use '../../styles/breakpoints.scss';
.theme-section {
  padding: 0;
  position: relative;
  > h2 {
    margin-top: 0;
  }
  &--margin-bottom {
    margin-bottom: variables.$spacing--large;
  }
  &--no-padding {
    padding: 0;
  }
  &--not-implemented {
    border: 1px solid red;
    &-text {
      color: red;
      font-size: 10px;
    }
  }

  &__loader {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    display: flex;
    background-color: #fff;
    z-index: 2;
    opacity: 0.7;
    justify-content: center;
    align-items: flex-start;
  }
}
